import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Archivo, IBM_Plex_Mono } from 'next/font/google'

// Archivo variable (graisse + largeur) : corps de texte en largeur normale,
// titres en largeur semi-étendue via l'utilitaire `heading` de globals.css.
const sans = Archivo({
    subsets: ['latin'],
    axes: ['wdth']
})

const mono = IBM_Plex_Mono({
    subsets: ['latin'],
    weight: ['400', '500', '600']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
